import React from 'react';
import { chartColors, themeColors } from '../../../constants';
import {
  makeStyles,
  Theme,
  createStyles,
  Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IChartProps, IReduxState } from '../../../types';
import { CardLayout } from '../CardLayouts/';
import { FormatHelper } from '../../../helpers';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    lastUpdate: {
      position: 'absolute',
      left: theme.spacing(1),
      top: 0,
      color: themeColors.white,
    },
    gaugeWrapper: {
      height: 175,
      width: 200,
    },
    firstEntry: {
      margin: `${theme.spacing(2)}px 0 0 0`,
      [theme.breakpoints.up('md')]: {
        margin: 0,
      },
      [theme.breakpoints.up('lg')]: {
        margin: `${theme.spacing(2)}px 0 ${theme.spacing(1)}px 0`,
      },
    },
    title: {
      marginTop: theme.spacing(2),
    },
    displayItem: {
      margin: theme.spacing(1),
    },
    display: {
      margin: theme.spacing(1),
    },
  })
);

export default function FuelConsumptionDisplay(props: IChartProps) {
  const { isPdfReport } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const formatHelper = new FormatHelper(t);

  const isHybrid = useSelector(
    (state: IReduxState) =>
      // !!state.machineDetails.machine.telemetrySnapshot?.isHybrid
      !!state.machineDetails.machine.isHybrid
  );

  const averageFuelConsumption = useSelector(
    (state: IReduxState) => state.machineDetails.averageFuelConsumption
  );

  const isThirdParty = useSelector(
    (state: IReduxState) =>
      state.machineDetails.machine.machineType.isThirdParty
  );

  const {
    engineFuelRate,
    engineFuelConsumed,
    mainDischargeConveyorFuelRate,
    sideDischargeConveyorFuelRate,
  } = averageFuelConsumption;

  return (
    <CardLayout
      cardStyle={{
        boxShadow:
          isHybrid && !isPdfReport
            ? `0.25rem 0.25rem 0 0 ${chartColors.electricBlue}`
            : 'none',
      }}
    >
      <Typography className={classes.lastUpdate} variant="caption">
        {`${t('graph.lastReceivedValue')}: ${FormatHelper.formatTimestamp(averageFuelConsumption.timestamp)}`}
      </Typography>

      <Typography
        align="center"
        variant="h5"
        className={classes.title}
      >
        {t('graph.averageFuelConsumption')}
      </Typography>

      <div className={classes.firstEntry}>
        <Typography align="center" variant="body1">
          {t('graph.engine')}
        </Typography>

        <Typography
          align="center"
          variant="h6"
          style={{ color: chartColors.purple }}
        >
          {formatHelper.formatUnitValue(engineFuelRate)}
        </Typography>
      </div>

      {!isThirdParty && (
        <>
          <div className={classes.display}>
            <Typography align="center" variant="body1">
              {t('graph.mainDischargeConveyor')}
            </Typography>

            <Typography
              align="center"
              variant="h6"
              style={{ color: chartColors.cyan }}
            >
              {formatHelper.formatUnitValue(mainDischargeConveyorFuelRate)}
            </Typography>
          </div>

          <div className={classes.display}>
            <Typography align="center" variant="body1">
              {t('graph.secondDischargeConveyor')}
            </Typography>

            <Typography
              align="center"
              variant="h6"
              style={{ color: chartColors.green }}
            >
              {formatHelper.formatUnitValue(sideDischargeConveyorFuelRate)}
            </Typography>
          </div>
        </>
      )}

      <br />

      <div className={classes.display}>
        <Typography align="center" variant="body1">
          {t('graph.engineFuelConsumed')}
        </Typography>

        <Typography
          align="center"
          variant="h6"
          style={{ color: chartColors.purple }}
        >
          {formatHelper.formatUnitValue(engineFuelConsumed)}
        </Typography>
      </div>
    </CardLayout>
  );
}
